import VueRouter from 'vue-router'
import store from '../../store'
import middlewarePipeline from './middlewarePipeline'

export default function router (routes) {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
      if (to.hash) {
        return {
          selector: to.hash,
          behavior: 'smooth'
        }
      }
      if (savedPosition) {
        return savedPosition
      }
    }
  })

  router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
      return next()
    }

    const middleware = to.meta.middleware
    const context = {
      to,
      from,
      next,
      store
    }

    return middleware[0]({
      ...context,
      nextMiddleware: middlewarePipeline(context, middleware, 1)
    })
  })

  return router
}
